import { c as _c } from "react/compiler-runtime";
import { useQuery } from "@tanstack/react-query";
import { type ConfigContextType } from "#/context/ConfigContext";
export const useAppConfig = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      queryKey: ["config"],
      queryFn: _temp2
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return useQuery(t0);
};
function _temp(res) {
  return res.json();
}
async function _temp2() {
  return fetch("/api/config").then(_temp);
}